import { WalletOption } from "@swapkit/core";

import { CtrlWallet, Keystore } from "~/assets";
import { cn } from "~/services/shadcn";

export const supportedWallets = [
  {
    id: WalletOption.CTRL,
    name: "Ctrl Wallet",
    icon: ({ className }: { className?: string }) => (
      <div
        className={cn(
          "flex h-full w-full items-center justify-center overflow-hidden rounded-xs bg-white object-contain object-center",
          className,
        )}
      >
        {/* uses percentage to maintain padding proportion */}
        <CtrlWallet className="p-[16%]" />
      </div>
    ),
    isAvailable: typeof window !== "undefined" && !!window?.xfi,
  },
  // {
  //   id: WalletOption.LEDGER,
  //   name: "Ledger",
  //   icon: <Ledger className="bg-black fill-white px-1.5 py-3" />,
  // },
  // {
  //   id: WalletOption.WALLETCONNECT,
  //   name: "WalletConnect",
  //   icon: <WalletConnect className="bg-[#3396ff] fill-white px-1 py-3" />,
  // },
  {
    id: WalletOption.KEYSTORE,
    name: "Keystore",
    icon: ({ className }: { className?: string }) => (
      <div
        className={cn(
          "flex h-full w-full items-center justify-center overflow-hidden rounded-xs bg-orange-gradient object-contain object-center",
          className,
        )}
      >
        <Keystore />
      </div>
    ),
  },
];
